import { getKind } from "../proto";
import { GDA_CONTINUOUS, GDA_DISCRETE } from "./types";
import { AuctionKindBigNumber } from "../../types/AuctionKind";

const intoVariantsAuction = (auctions) => {
  const variantsAuctions = {
    ...auctions.reduce(
      (acc, auc) => {
        let _acc = Object.assign({}, acc);
        for (const product of auc.products) {
          if (!_acc[product.native_variant_id]) {
            _acc["variants"].push(product);
          }
          _acc[product.native_variant_id] = [];
        }

        return _acc;
      },
      { variants: [] }
    ),
  };

  for (const auction of auctions) {
    for (const product of auction.products) {
      variantsAuctions[product.native_variant_id].push(auction);
    }
  }

  const variantsAuction = {
    variants: variantsAuctions.variants,
  };
  for (const variantKey of Object.keys(variantsAuctions).filter(
    (k) => k !== "variants"
  )) {
    const _variantAuctions = Object.assign([], variantsAuctions[variantKey]);

    const latestAuction = _variantAuctions.reduce((prevAuc, auc) => {
      return auc.auctionEndTime.getTime() > prevAuc.auctionEndTime.getTime()
        ? auc
        : prevAuc;
    });

    variantsAuction[variantKey] = latestAuction;
  }

  return variantsAuction;
};

const reconcileAuctionResponse = (auction, auctionState) => {
  const normalized = Object.assign({}, auctionState, {
    id: auction.auction_external_id,
    stateExternalId: auctionState.external_id,
    kind: getKind(window.location.search) ?? auction.kind,
    products: auction.products,
    auctionStartTime: new Date(auction.start_time + "Z"),
    auctionEndTime: new Date(auction.end_time + "Z"),
  });

  switch (normalized.kind) {
    case GDA_CONTINUOUS.KIND: {
      return Object.assign({}, normalized, {
        last_epoch: new Date(auctionState.last_epoch + "Z").getTime() / 1000,
        layout: AuctionKindBigNumber,
        priceFloor: auctionState.price_floor,
      });
    }
    case GDA_DISCRETE.KIND: {
      return Object.assign({}, normalized, {
        start_epoch: new Date(auctionState.start_epoch + "Z").getTime() / 1000,
        layout: AuctionKindBigNumber,
        priceFloor: auctionState.price_floor,
      });
    }
    default: {
      return normalized;
    }
  }
};

export const reconcileAuctionsResponse = (auctions) => {
  /*

    since a product with many variants

  */

  return intoVariantsAuction(
    auctions.map((auction) =>
      reconcileAuctionResponse(auction, { ...auction.auction_state[0] })
    )
  );
};

export const reconcileRealtimeUpdateIntoAuction = (auction, realtimeUpdate) => {
  /*
    realtimeUpdate: {
      "schema": "public",
      "table": "gda_discrete_state",
      "commit_timestamp": "2023-01-17T09:18:57Z",
      "eventType": "UPDATE",
      "new": {
        "auction_id": 9,
        "decay_rate": 0.001,
        "external_id": "f02e6ac2-139f-4540-8c10-cd182df80452",
        "id": 8,
        "quantity": 1,
        "scale_factor": 1.01,
        "sold": 7,
        "start_epoch": "2023-01-12T10:14:27",
        "starting_price": 100
      },
      "old": {
        "id": 8
      },
      "errors": null
    }
  */

  return reconcileAuctionResponse(
    Object.assign({}, auction),
    realtimeUpdate.new
  );
};

